// Generated code for Big.Entities.Nationaliteit.
// Edit _Enum.tst to change the generated output.

export enum Nationaliteit {
    onbekend = 0,
    nederlandse = 1,
    behandeldalsNederlander = 2,
    slowaakse = 27,
    tsjechische = 28,
    burgerVanBosniëHerzegovina = 29,
    georgische = 30,
    turkmeense = 31,
    tadzjiekse = 32,
    oezbeekse = 33,
    oekraïense = 34,
    kirgizische = 35,
    moldavische = 36,
    kazachse = 37,
    belarussische = 38,
    azerbeidzjaanse = 39,
    armeense = 40,
    russische = 41,
    sloveense = 42,
    kroatische = 43,
    letse = 44,
    estische = 45,
    litouwse = 46,
    marshalleilandse = 47,
    myanmarese = 48,
    namibische = 49,
    albanese = 50,
    andorrese = 51,
    belgische = 52,
    bulgaarse = 53,
    deense = 54,
    burgerVandeBondsrepubliekDuitsland = 55,
    finse = 56,
    franse = 57,
    jemenitische = 58,
    griekse = 59,
    britsburger = 60,
    hongaarse = 61,
    ierse = 62,
    ijslandse = 63,
    italiaanse = 64,
    joegoslavische = 65,
    liechtensteinse = 66,
    luxemburgse = 67,
    maltese = 68,
    monegaskische = 69,
    noorse = 70,
    oostenrijkse = 71,
    poolse = 72,
    portugese = 73,
    roemeense = 74,
    burgerVandeSovjetUnie = 75,
    sanMarinese = 76,
    spaanse = 77,
    tsjechoSlowaakse = 78,
    vaticaanse = 79,
    zweedse = 80,
    oostDuitse = 82,
    britsonderdaan = 83,
    eritrese = 84,
    britsoverzeesburger = 85,
    macedonische = 86,
    kosovaarse = 87,
    algerijnse = 100,
    angolese = 101,
    burundese = 104,
    botswaanse = 105,
    burkinese = 106,
    centraalAfrikaanse = 108,
    comorese = 109,
    burgerVanCongo = 110,
    beninse = 111,
    egyptische = 112,
    equatoriaalGuinese = 113,
    ethiopische = 114,
    djiboutiaanse = 115,
    gabonese = 116,
    gambiaanse = 117,
    ghanese = 118,
    guinese = 119,
    ivoriaanse = 120,
    kaapverdische = 121,
    kameroense = 122,
    kenyaanse = 123,
    zaïrese = 124,
    lesothaanse = 125,
    liberiaanse = 126,
    libische = 127,
    malagassische = 128,
    malawische = 129,
    malinese = 130,
    marokkaanse = 131,
    mauritaanse = 132,
    mauritiaanse = 133,
    mozambikaanse = 134,
    swazische = 135,
    nigerese = 136,
    nigeriaanse = 137,
    ugandese = 138,
    guineeBissause = 139,
    zuidAfrikaanse = 140,
    zimbabwaanse = 142,
    rwandese = 143,
    burgerVanSãoToméenPrincipe = 144,
    senegalese = 145,
    sierraLeoonse = 147,
    soedanese = 148,
    somalische = 149,
    tanzaniaanse = 151,
    togolese = 152,
    tsjadische = 154,
    tunesische = 155,
    zambiaanse = 156,
    zuidSoedanese = 157,
    bahamaanse = 200,
    belizaanse = 202,
    canadese = 204,
    costaRicaanse = 205,
    cubaanse = 206,
    dominicaanse = 207,
    salvadoraanse = 208,
    guatemalaanse = 211,
    haïtiaanse = 212,
    hondurese = 213,
    jamaicaanse = 214,
    mexicaanse = 216,
    nicaraguaanse = 218,
    panamese = 219,
    burgerVanTrinidadenTobago = 222,
    amerikaansburger = 223,
    argentijnse = 250,
    barbadaanse = 251,
    boliviaanse = 252,
    braziliaanse = 253,
    chileense = 254,
    colombiaanse = 255,
    ecuadoraanse = 256,
    guyaanse = 259,
    paraguayaanse = 261,
    peruaanse = 262,
    surinaamse = 263,
    uruguayaanse = 264,
    venezolaanse = 265,
    grenadaanse = 267,
    burgerVanSaintKittsenNevis = 268,
    afghaanse = 300,
    bahreinse = 301,
    bhutaanse = 302,
    burmaanse = 303,
    bruneise = 304,
    cambodjaanse = 305,
    sriLankaanse = 306,
    chinese = 307,
    cyprische = 308,
    filipijnse = 309,
    taiwanese = 310,
    indiase = 312,
    indonesische = 313,
    iraakse = 314,
    iraanse = 315,
    israëlische = 316,
    japanse = 317,
    noordJemenitische = 318,
    jordaanse = 319,
    koeweitse = 320,
    laotiaanse = 321,
    libanese = 322,
    maldivische = 324,
    maleisische = 325,
    mongolische = 326,
    omaanse = 327,
    nepalese = 328,
    noordKoreaanse = 329,
    pakistaanse = 331,
    qatarese = 333,
    saoediArabische = 334,
    singaporese = 335,
    syrische = 336,
    thaise = 337,
    burgerVanDeVerenigdeArabischeEmiraten = 338,
    turkse = 339,
    zuidJemenitische = 340,
    zuidKoreaanse = 341,
    vietnamese = 342,
    bengalese = 345,
    australische = 400,
    papoeaNieuwGuinese = 401,
    nieuwZeelandse = 402,
    westSamoaanse = 404,
    samoaanse = 405,
    burgerVanAntiguaenBarbuda = 421,
    vanuatuaanse = 424,
    fijische = 425,
    burgerVanBritseafhankelijkegebieden = 429,
    tongaanse = 430,
    nauruaanse = 431,
    palause = 432,
    amerikaansonderdaan = 437,
    salomonseilandse = 442,
    micronesische = 443,
    seychelse = 444,
    kiribatische = 445,
    tuvaluaanse = 446,
    saintLuciaanse = 447,
    burgerVanDominica = 448,
    burgerVanStVincentendeGrenadines = 449,
    britishNationalOverseas = 450,
    burgerVanDemocratischeRepubliekCongo = 451,
    burgerVanTimorLeste = 452,
    burgerVanServiëenMontenegro = 453,
    servische = 454,
    montenegrijnse = 455,
    staatloos = 499,
    vastgesteldNietNederlander = 500
}
(Nationaliteit as any).name = 'Nationaliteit';
